// extracted by mini-css-extract-plugin
export default {"Grid":"createDynamicBanner_Grid__4J4I6","Span":"createDynamicBanner_Span__8EK2r"};